//Components
import Layout from '../../hocs/Layout';
import { useEffect, useState } from 'react';
import { PriceForm } from '../../components/aditional/PriceForm';
import { Link } from 'react-router-dom';
import { projects } from '../../helpers/Portfolio';
//Styles
import '../../styles/services.css';


const WebDesign = () => {

	const [openPriceForm, setOpenPriceForm] = useState(false);
	
	const toggleOpenForm = () => {
    	setOpenPriceForm(!openPriceForm);
    }

    const featuredProjects = projects.filter((project) => project.featured);

	useEffect(() => {
		window.scrollTo(0,0);
	}, []);

	return (
		<Layout>
			<div className='container-webd-header'>
				<h3 className='title-max'>Diseño Web</h3>
				<p className='webd-header-text'>Creamos sitios web personalizados, modernos y optimizados para tu negocio</p>
				<div className='contain-webd-boxes'>
					<div className='webd-box'>
						<img src={require(`../../images/comprobar.webp`)} alt='a-medida' />
						<h4>100% a medida, sin plantillas</h4>
					</div>
					<div className='webd-box'>
						<img src={require(`../../images/optimizacion-seo.webp`)} alt='optimizacion-seo' />
						<h4>Optimización SEO desde el inicio</h4>
					</div>
					<div className='webd-box'>
						<img src={require(`../../images/adaptado.webp`)} alt='adaptado' />
						<h4>Diseño adaptable en todos los dispositivos</h4>
					</div>
					<div className='webd-box'>
						<img src={require(`../../images/integracion.webp`)} alt='integracion' />
						<h4>Integración con herramientas de marketing</h4>
					</div>
				</div>
			</div>
			<div className='container-webd-process'>
				<h3 className='home-titles-white'>Nuestro proceso</h3>
				<div className='container-process-boxes'>
	      			<div className='container-process-box'>
						<img src={require(`../../images/briefing.webp`)} alt='briefing'  className='process-img' />
						<h3 className='process-text'>Briefing y análisis</h3>
					</div>
					<div className='container-process-box'>
						<img src={require(`../../images/web-design.webp`)} alt='ux-ui'  className='process-img' />
						<h3 className='process-text'>Diseño UX/UI</h3>
					</div>
					<div className='container-process-box'>
						<img src={require(`../../images/configuracion.webp`)} alt='configuracion'  className='process-img' />
						<h3 className='process-text'>Desarrollo y pruebas</h3>
					</div>
					<div className='container-process-box'>
						<img src={require(`../../images/lanzamiento.webp`)} alt='lanzamiento'  className='process-img' />
						<h3 className='process-text'>Entrega y soporte</h3>
					</div>
	    		</div>
    		</div>
			<div className='container-webd-examples'>
				<h3 className='home-titles'>Algunos de nuestros trabajos</h3>
				<div className='contain-portfolio-webd'>
					{featuredProjects.map((project) => (
      					<div key={project.id} className="portfolio-card">
        					<img src={project.image} alt={project.name_es} className="portfolio-image" />
        					<h3>{project.name_es}</h3>
        					<p>{project.description_es.substring(0, 120)}...</p>
        					<Link to={project.link} style={{textDecoration: 'none'}} target="_blank" className="btn btn3">Ver proyecto</Link>
      					</div>
    				))}
				</div>
				<button className='btn btn1' onClick={toggleOpenForm} style={{textDecoration:'none'}}>Solicitar una cotización</button>
			</div>
			<PriceForm toggleOpen={toggleOpenForm} openPriceForm={openPriceForm} />
		</Layout>
	);
};

export default WebDesign